<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <h2>Inscription</h2>
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-3">
          <label for="name">Pseudo</label>
          <input
            type="text"
            id="name"
            class="form-control"
            (blur)="checkUsernameAvailability()"
            formControlName="name"
            placeholder="Entrez votre nom"
            [ngClass]="{ 'is-invalid': usernameTaken }"
            />
            <!-- Erreur requise -->
            @if (registerForm.get('name')?.hasError('required') && registerForm.get('name')?.touched) {
              <div class="text-danger">
                Le nom est requis.
              </div>
            }

            <!-- Erreur nom d'utilisateur déjà pris -->
            @if (!registerForm.get('name')?.hasError('required') && usernameTaken) {
              <div class="text-danger">
                Ce nom d'utilisateur est déjà pris.
              </div>
            }
          </div>

          <div class="form-group mb-3">
            <label for="email">Adresse e-mail</label>
            <input type="email" id="email" class="form-control" formControlName="email" placeholder="Entrez votre e-mail" />
            @if (registerForm.get('email')?.invalid && registerForm.get('email')?.touched) {
              <div class="text-danger">
                L'adresse e-mail est requise et doit être valide.
              </div>
            }
          </div>

          <div class="form-group mb-3">
            <label for="password">Mot de passe</label>
            <input type="password" id="password" class="form-control" formControlName="password" placeholder="Entrez votre mot de passe" autocomplete="on"/>
            @if (registerForm.get('password')?.invalid && registerForm.get('password')?.touched) {
              <div class="text-danger">
                Le mot de passe est requis (minimum 6 caractères).
              </div>
            }
          </div>

          <div class="form-group mb-3">
            <label for="confirmPassword">Confirmez le mot de passe</label>
            <input type="password" id="confirmPassword" class="form-control" formControlName="confirmPassword" placeholder="Confirmez votre mot de passe" autocomplete="on" />

            <!-- Affiche un message d'erreur si la confirmation du mot de passe est invalide et touchée -->
            @if (registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched) {
              <div class="text-danger">
                <!-- Si la confirmation est requise -->
                @if (registerForm.get('confirmPassword')?.errors?.['required']) {
                  <div>
                    La confirmation du mot de passe est requise.
                  </div>
                }
              </div>
            }

            <!-- Affiche un message si les mots de passe ne correspondent pas -->
            @if (registerForm.errors?.['passwordMismatch'] && registerForm.get('confirmPassword')?.touched) {
              <div class="text-danger">
                Les mots de passe ne correspondent pas.
              </div>
            }
          </div>

          <button type="submit" class="btn btn-primary" [disabled]="registerForm.invalid">
            S'inscrire
          </button>
        </form>
      </div>
    </div>
  </div>
